/* eslint-disable comma-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { ReactNode } from 'react';
import cn from 'classnames';
import {
  ErrorCross,
  ExclamationPoint,
  SuccessTick,
  Info,
} from '@cashew/assets';
import Modal from '@cashew/modal';
import './index.css';

type ModalConfirmProps = {
  isVisible: boolean;
  onClose: () => void;
  confirmTitle: string;
  confirmDescription: any;
  confirmButtons: React.ReactNode;
  resultTitle: string;
  resultDescription?: any;
  resultButtons: React.ReactNode;
  showResult: boolean;
  showCloseButton: boolean;
  dispatchError?: string;
  confirmForm?: React.ReactNode | any;
  confirmTitleComponent?: React.ReactNode;
  resultDescriptionComponent?: React.ReactNode;
  resultStatus: 'warning' | 'error' | 'info' | 'success' | 'none';
};

const svgList = {
  error: <ErrorCross />,
  warning: <ExclamationPoint />,
  success: <SuccessTick />,
  info: <Info />,
  none: '',
};

export default ({
  isVisible,
  onClose,
  confirmTitle,
  confirmDescription,
  confirmButtons,
  resultTitle,
  resultDescription,
  resultButtons,
  showResult,
  showCloseButton,
  confirmForm,
  confirmTitleComponent,
  resultDescriptionComponent,
  resultStatus,
}: ModalConfirmProps) => {
  const resultBox = (
    <div className="result-box">
      <div className={cn('result__icon', `result__icon__${resultStatus}`)}>
        {svgList[resultStatus]}
      </div>
      <div className="result__text">
        {resultTitle && (
          <h2 dangerouslySetInnerHTML={{ __html: resultTitle }} />
        )}
        {resultDescriptionComponent}
        {resultDescription && (
          <p dangerouslySetInnerHTML={{ __html: resultDescription }} />
        )}
      </div>
      <hr />
    </div>
  );

  const baseBox = (
    <>
      {confirmTitleComponent}
      <h2 dangerouslySetInnerHTML={{ __html: confirmTitle }} />
      <p className="dangerouslySetInnerHTMLStyle">{confirmDescription}</p>
      {confirmForm}
    </>
  );

  return (
    <div>
      <Modal
        className={cn(
          'modal-confirm',
          { 'modal-confirm-result': showResult },
          { [`modal-confirm-result-${resultStatus}`]: resultStatus }
        )}
        isVisible={isVisible}
        onClose={onClose}
        showCloseButton={showCloseButton}
      >
        <div>
          <div className="modal-content">
            {showResult ? resultBox : baseBox}
          </div>
          {resultStatus === 'none' ? null : (
            <div className="hrSpacer">
              <hr />
            </div>
          )}
          <div className="modal-footer">
            {showResult ? resultButtons : confirmButtons}
          </div>
        </div>
      </Modal>
    </div>
  );
};
